import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../src/i18n/translate';

export default class ExpandableList extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired
    })),
    minVisibleItems: PropTypes.number.isRequired,
    onExpand: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      showMore: false
    }
    this.onClickHandler = this.onClickHandler.bind(this);
  }

  onClickHandler(event) {
    const { onExpand } = this.props;
    const showMore = !this.state.showMore;
    this.setState({ showMore });
    if (onExpand) {
      onExpand(showMore, event);
    }
  }

  showButtonCopy(listItemsNr) {
    if (!this.state.showMore) {
      return <span>+ {listItemsNr - this.props.minVisibleItems} {i18n.t('More')}</span>
    }
    return <span>{i18n.t('Less')}</span>
  }

  render() {
    const listItemsNr = this.props.data.length;

    let list = this.props.data.map((item, index) => {
      if (index < this.props.minVisibleItems) {
        return <li key={index}>{item.label}</li>
      }
      return this.state.showMore ? <li key={index}>{item.label}</li> : null;
    });

    return (
      <div className={this.props.className}>
        <ul>
          {list}
        </ul>
        {listItemsNr > this.props.minVisibleItems ? <button className="toggle-button" onClick={this.onClickHandler}>{this.showButtonCopy(listItemsNr)}</button> : null}
      </div>
    );

  }
}

ExpandableList.defaultProps = {
  minVisibleItems: 3
}